module.exports = __webpack_public_path__ + "img/DAVID_CANNON_48-rs.7cf7c14f.jpg";